import { Group } from "@dinahmoe/dmafjs-visual";
import { coreEngine } from "@dinahmoe/dmafjs-core";

class Matrix extends Group {
  namespace = "visual:matrix";

  init(node, event) {
    super.init(node, event);

    const dotSize = 2;
    const spacing = 72;
    const cols = 2880 / spacing;
    const rows = 1440 / spacing;

    const fadeRows = 8;

    for (let row = 0; row < rows; row++) {
      let opacity = 1;
      if (row < fadeRows) {
        opacity = 0.125 * (row + 1);
      } else if (row >= rows - fadeRows) {
        opacity = 0.125 * (rows - row);
      }

      for (let col = 0; col < cols; col++) {
        coreEngine.create({
          namespace: "visual:group",
          parentUid: node.uid,
          position: { x: col * spacing, y: row * spacing },
          size: { width: dotSize, height: dotSize },
          border: { radius: dotSize / 2 },
          appearance: { background: "#ffffff", opacity }
        });
      }
    }
  }
}

const matrix = new Matrix();
export { matrix, Matrix };
